"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var IntroducersIcon = function IntroducersIcon(props) {
  return _react["default"].createElement("svg", {
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 82",
    width: props.width || "70px",
    height: props.height || "70px"
  }, _react["default"].createElement("defs", null, _react["default"].createElement("polygon", {
    points: "0.2867 0 33.1487 0 33.1487 32.8617 0.2867 32.8617"
  })), _react["default"].createElement("g", null, _react["default"].createElement("g", {
    transform: "translate(-109.000000, -109.000000)"
  }, _react["default"].createElement("g", {
    transform: "translate(109.000000, 109.000000)"
  }, _react["default"].createElement("path", {
    d: "M34.622,73.5529 C34.622,74.9249 33.51,76.0379 32.137,76.0379 C30.765,76.0379 29.652,74.9249 29.652,73.5529 C29.652,72.1809 30.765,71.0679 32.137,71.0679 C33.51,71.0679 34.622,72.1809 34.622,73.5529",
    fill: props.fill || "#71c4ff"
  }), _react["default"].createElement("path", {
    d: "M21.0546,24.1956 C16.3106,24.1956 12.4506,28.0546 12.4506,32.7996 C12.4506,37.5436 16.3106,41.4026 21.0546,41.4026 C25.7986,41.4026 29.6586,37.5436 29.6586,32.7996 C29.6586,28.0546 25.7986,24.1956 21.0546,24.1956 M21.0546,45.3786 C14.1186,45.3786 8.4756,39.7356 8.4756,32.7996 C8.4756,25.8636 14.1186,20.2196 21.0546,20.2196 C27.9916,20.2196 33.6336,25.8636 33.6336,32.7996 C33.6336,39.7356 27.9916,45.3786 21.0546,45.3786",
    fill: props.fill || "#71c4ff"
  }), _react["default"].createElement("g", {
    transform: "translate(39.000000, 0.000000)"
  }, _react["default"].createElement("path", {
    d: "M16.7177,3.9757 C9.8497,3.9757 4.2627,9.5627 4.2627,16.4307 C4.2627,23.2987 9.8497,28.8857 16.7177,28.8857 C23.5857,28.8857 29.1727,23.2987 29.1727,16.4307 C29.1727,9.5627 23.5857,3.9757 16.7177,3.9757 M16.7177,32.8617 C7.6577,32.8617 0.2867,25.4907 0.2867,16.4307 C0.2867,7.3707 7.6577,-0.0003 16.7177,-0.0003 C25.7777,-0.0003 33.1487,7.3707 33.1487,16.4307 C33.1487,25.4907 25.7777,32.8617 16.7177,32.8617",
    fill: props.fill || "#71c4ff"
  })), _react["default"].createElement("path", {
    d: "M75.87,82 L75.858,82 L5.836,81.882 C2.596,81.794 0,79.148 0,75.984 L0,64.036 C0,57.443 9.505,50.068 22.225,50.068 C23.324,50.068 24.213,50.958 24.213,52.056 C24.213,53.155 23.324,54.044 22.225,54.044 C10.904,54.044 3.975,60.512 3.975,64.036 L3.975,75.984 C3.975,77.015 4.836,77.877 5.893,77.906 L75.866,78.024 L75.87,78.024 C76.397,78.024 76.896,77.819 77.271,77.444 C77.647,77.067 77.855,76.568 77.855,76.036 L77.855,54.867 L77.679,53.619 C77.132,52.039 76.151,50.581 74.607,49.045 C70.264,44.955 63.223,42.49 55.812,42.49 C42.139,42.49 33.769,50.414 33.769,54.727 L33.769,67.462 C33.769,68.561 32.881,69.45 31.782,69.45 C30.683,69.45 29.794,68.561 29.794,67.462 L29.794,54.727 C29.794,47.23 41.16,38.514 55.812,38.514 C64.211,38.514 72.268,41.383 77.372,46.19 C79.441,48.244 80.783,50.309 81.511,52.542 C81.548,52.65 81.573,52.763 81.591,52.877 L81.811,54.456 C81.825,54.545 81.831,54.636 81.831,54.727 L81.831,76.036 C81.831,77.632 81.21,79.131 80.08,80.257 C78.954,81.381 77.46,82 75.87,82",
    fill: props.fill || "#71c4ff"
  })))));
};

var _default = IntroducersIcon;
exports["default"] = _default;